<template>
  <router-link :to="go_to()" class="sim_task link">
    <tr>
      <td :data-label="translate('sim_task_list.name')">
        {{ sim_task.title }}
      </td>
      <td :data-label="translate('sim_task_list.target_result')">
        {{ sim_task.target_result }}
      </td>
      <td :data-label="translate('sim_task_list.status')">
        {{ sim_task.status }}
      </td>
      <td :data-label="translate('sim_task_list.source')">
        {{ sim_task.source_type }}
      </td>
      <td :data-label="translate('sim_task_list.priority')">
        {{ sim_task.priority }}
      </td>
      <td class="w7per" :data-label="translate('sim_task_list.task_list.items_count')">
        {{ sim_task.items_count }}
      </td>
      <td class="w7per" :data-label="translate('sim_task_list.task_list.started_at')">
        {{ get_date(sim_task.started_at, ts_date_options) }}
      </td>
      <td class="w7per" :data-label="translate('sim_task_list.task_list.finished_at')">
        {{ get_date(sim_task.finished_at, ts_date_options) }}
      </td>
      <td class="w7per" :data-label="translate('sim_task_list.task_list.created_at')">
        {{ get_date(sim_task.created_at, ts_date_options) }}
      </td>
      <td class="w7per" :data-label="translate('sim_task_list.task_list.updated_at')">
        {{ get_date(sim_task.updated_at, ts_date_options) }}
      </td>
    </tr>
  </router-link>
</template>
<script>

export default {
  name: 'SimTaskListItem',
  components: {
  },
  props: ["sim_task"],
  data () {
    return {
      ts_date_options:{
        hour12: false,
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }
    }
  },
  computed: {

  },
  activated () {

  },
  mounted () {

  },
  methods: {
    go_to() {
      return { path: '/sim_task/' + this.sim_task.id }
    },

  }
}
</script>

<style lang="scss" scoped>
.sim_task{
  cursor: pointer;
  color: #252422;
  &:hover tr{
    background-color: #eee;
  }
  td{
    font-size: 12px;
    overflow: hidden;
  }
}
</style>
